import { FC, useContext, useEffect } from 'react';

import { Footer } from 'components/general/Footer';
import { AuthContext, CommonContext } from '@repo-level/core-front';
import { ModalsContext } from 'contexts/modal';
import { Background } from 'components/Background';
import { AdditionalModal } from 'modules/additionalModal';
import { Nav } from 'components/general/Nav';
import { use100vh } from 'hooks/realHeight';
import { TabBarContext } from 'contexts/tabBarSize';
import { useAutoRegistrationModal } from 'hooks/autoRegistration';
import { usePaymentNotification } from 'hooks/paymentNotification';
import { AddonsContext } from 'contexts/addons';
import { EmailConfirmPopup } from 'components/EmailConfirm';
import { HeaderMobile } from 'components/general/Header/HeaderMobile';
import { useBonusCode } from 'hooks/bonusCode';
import { useScrollToElement } from 'hooks/scroll';

import { ScMain, ScLayout } from './styled';
import { useNewTermsAndConditions } from 'hooks/newTermsAndConditions';
import { useReferralProgramNotifications } from 'hooks/useReferralProgramNotifications';

export const Layout: FC = ({ children }) => {
  const { fetchProject } = useContext(CommonContext);
  const { user } = useContext(AuthContext);
  const { modalComponent: modals } = useContext(ModalsContext);
  const { isEmailConfirmationPopup, emailConfirmationPopupHeight } = useContext(
    AddonsContext
  );

  useAutoRegistrationModal();

  const realHeight = use100vh();

  const { tabBarHeight } = useContext(TabBarContext);

  usePaymentNotification();

  useBonusCode();

  useReferralProgramNotifications();

  useNewTermsAndConditions();

  useScrollToElement();

  useEffect(() => {
    fetchProject();
  }, [fetchProject, user]);

  return (
    <>
      <AdditionalModal bottom={tabBarHeight} />
      <ScLayout
        realHeight={realHeight}
        withEmailConfirmationPopup={isEmailConfirmationPopup}
        emailConfirmationPopupHeight={emailConfirmationPopupHeight}
      >
        {isEmailConfirmationPopup && <EmailConfirmPopup />}
        <Nav />
        <ScMain realHeight={realHeight}>
          <Background />
          <HeaderMobile />

          {children}
          <Footer />
        </ScMain>
      </ScLayout>
      {modals}
    </>
  );
};
